import { Box, Checkbox, TableCell, TableRow, Tooltip } from "@mui/material";
import { PermissionWrapper } from "../../../../wrappers";
import RestoreIcon from '@mui/icons-material/Restore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import moment from 'moment';
import { trackActivity } from "../../../../utils/mixpanel";
import LessMoreComp from "../../../../shared_elements/components/CustomLessMoreComp";
import { dateMonthYearDateFormat } from "../../../../constants";
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import AuditPopover from "../../../../shared_elements/components/popover";
import MoreVertIcon from '@mui/icons-material/MoreVert';
const NotesList=({onView,onEdit,onDelete,viewFile,slug,item,bulk,viewRevisonHistory,toggleBulkOps,uploadedFileData,viewFileStatus})=>{
     const handleItemClicked = (page_type) => {
            trackActivity('Item Clicked', { page_title: `Notes Listing`, page_type: page_type, })
        }
     return (
        <TableRow >
            <TableCell className="table-actions-list">
                <Box className="table-icon-container">
                    <PermissionWrapper extraProps={{ application: 'lease_revamp', feature: 'notes_module', operationType: ['D'] }}>
                        <Checkbox disableRipple style={{ verticalAlign: 'super' }} color="primary" size="small" checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)} />
                    </PermissionWrapper>
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <Tooltip title="Revision History">
                        <RestoreIcon className='revision-history' fontSize="small" color="primary" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: "pointer" }} />
                    </Tooltip>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "notes_module", operationType: ['R'] }}>
                        <Tooltip title="View">
                            <VisibilityIcon fontSize="small" onClick={() => { onView(); handleItemClicked('ViewIcon') }} color="primary" sx={{ cursor: "pointer" }} />
                        </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "notes_module", operationType: ['U'] }}>
                        <Tooltip title="Edit">
                            <EditIcon fontSize="small" color="primary" onClick={() => { onEdit(); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} />
                        </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "notes_module", operationType: ['D'] }}>
                        <Tooltip title="Delete">
                            <DeleteIcon fontSize="small" onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} color="error" sx={{ cursor: "pointer" }} />
                        </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "notes_module", operationType: ['R'] }}>
                        {
                            item?.attachments?.length > 0 && (
                                <Tooltip title="Attached File(s)">
                                    <Box className="attachment-container">
                                        <AttachFileIcon fontSize="small" color="primary" onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                        <Box className="attachment-count"> ({item.attachments.length}) </Box>
                                    </Box>
                                </Tooltip>
                            )
                        }
                    </PermissionWrapper>
                   { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                </Box>
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.type || '--'}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><LessMoreComp name={item?.description} lessMr='description' /></TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><LessMoreComp name={item?.remarks} lessMr='details' /></TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.start_date ? moment(item.start_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.end_date ? moment(item.end_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
        </TableRow>
    );
}

export default NotesList;